'use client';

const getClarity = () => {
  if (typeof window === 'undefined') return null;
  return window.clarity;
};

const readText = (value) => {
  if (typeof value !== 'string') return '';
  const trimmed = value.trim();
  return trimmed || '';
};

const runClarity = (callback) => {
  if (typeof window === 'undefined') return;

  const invoke = () => {
    const clarity = getClarity();
    if (typeof clarity === 'function') {
      callback(clarity);
      return true;
    }
    return false;
  };

  if (invoke()) return;

  if (typeof window.setTimeout === 'function') {
    window.setTimeout(() => {
      invoke();
    }, 200);
  }
};

export function clarityIdentifyUser(user) {
  if (!user) return;

  const id = [user?.id, user?._id, user?.customerId, user?.userId].find((value) => readText(value));
  const email = readText(user?.email);
  const name = readText(user?.name || [user?.firstName, user?.lastName].filter(Boolean).join(' '));

  if (!id && !email && !name) return;

  runClarity((clarity) => {
    clarity('identify', id || email || name, email || undefined, name || undefined);
  });
}

export function clarityEvent(eventName) {
  const name = readText(eventName);
  if (!name) return;

  runClarity((clarity) => {
    clarity('event', name);
  });
}
